import { LockPeriods } from '@/constants'
import { bnHelper } from '@/helpers/bignumber-helper'
import { FarmLPHandler } from '@/helpers/farmLP-handler'
import { chunk } from 'lodash-es'
import { IReactionDisposer, observable } from 'mobx'
import { asyncAction } from 'mobx-utils'
import { Subject } from 'rxjs'

export class FarmsViewModel {
  @observable loading = false
  @observable pools: any = []

  constructor() {
    this.loadData()
  }

  @asyncAction *loadData() {
    this.loading = true
    const sbPools = Object.values(LockPeriods).map(item => new FarmLPHandler('SB', item.value))
    const stePools = Object.values(LockPeriods).map(item => new FarmLPHandler('STE', item.value))

    const pools = [...sbPools, ...stePools]

    yield Promise.all(pools.map(pool => pool.load()))

    const groups = chunk(pools, 6)
    for (const subPools of groups) {
      let promises: any = []
      subPools.map(pool => {
        promises = [...promises, pool.getTotalLockedAmount(0), pool.getUserLength(0), pool.getFarmLiquidityAndApy()]
      })
      yield Promise.all(promises)
    }

    const sortedPools = pools.sort((a, b) => {
      if (bnHelper.lt(a.apy, b.apy)) return 1
      if (bnHelper.gt(a.apy, b.apy)) return -1
      return 0
    })
    this.pools = sortedPools
    this.loading = false
  }
}
